import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './SlateViewChip.css';

const SlateViewChip = ({ type, count, className }) => {
  const { t } = useTranslation();

  return (
    <div className={'slate-view-chip' + (className ? ' ' + className : '')}>
      <span className="slate-view-chip-type">{t(`settings:${type}`)}</span>
      <span className="slate-view-chip-divider" />
      <span className="slate-view-chip-count">
        {count && count.toLocaleString()}
      </span>
    </div>
  );
};

SlateViewChip.propTypes = {
  type: PropTypes.string.isRequired,
  count: PropTypes.number,
  className: PropTypes.string,
};

export default SlateViewChip;
